/**
 * @generated SignedSource<<c152fafb707d40119b94fe8ed314183c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type diligenceReportPage_Query$variables = Record<PropertyKey, never>;
export type diligenceReportPage_Query$data = {
  readonly exports: ReadonlyArray<{
    readonly byteSize: number | null | undefined;
    readonly createdAt: any;
    readonly downloadPath: string | null | undefined;
    readonly errorMessage: string | null | undefined;
    readonly filename: string;
    readonly finishedAt: any | null | undefined;
    readonly id: string;
    readonly kind: string;
    readonly kindLabel: string;
    readonly label: string | null | undefined;
    readonly status: string;
    readonly summary: string | null | undefined;
  }>;
};
export type diligenceReportPage_Query = {
  response: diligenceReportPage_Query$data;
  variables: diligenceReportPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "kind",
        "value": "DILIGENCE_KPIS"
      }
    ],
    "concreteType": "Export",
    "kind": "LinkedField",
    "name": "exports",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kind",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "kindLabel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "byteSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finishedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadPath",
        "storageKey": null
      }
    ],
    "storageKey": "exports(kind:\"DILIGENCE_KPIS\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "diligenceReportPage_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "diligenceReportPage_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f33771a26c1c94bf680e9ab5e21ed5d3",
    "id": null,
    "metadata": {},
    "name": "diligenceReportPage_Query",
    "operationKind": "query",
    "text": "query diligenceReportPage_Query {\n  exports(kind: \"DILIGENCE_KPIS\") {\n    id\n    kind\n    kindLabel\n    label\n    status\n    summary\n    byteSize\n    errorMessage\n    createdAt\n    finishedAt\n    filename\n    downloadPath\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c6bc1428d1f290ce02d23a538ffe6a5";

export default node;
